import { auth } from "./auth";
import { $admin } from "./api/admin";
import apiEndpoints from "@/constants/api-endpoints";

/**
 * Get list of all users
 * @param {Object} params Http request payload
 * @returns {Promise} List of users
 */
export const getUsers = (params) => {
  return $admin.get(apiEndpoints.users, { params });
};

/**
 * Creates a new login account of the user on the basis of the email and password
 * input so that he can login into the application
 * @param {String} email Email address of the user account to be created
 * @param {String} password Password of the user account
 * @returns {Promise}
 */
export const createUser = (email, password) => {
  return auth.createUserWithEmailAndPassword(email, password);
};

/**
 * Create user Profile by hitting server api
 * @param {Object} param - pass attribute to api
 * @returns {Promise}
 */
export const createUserProfile = (params) => {
  return $admin.post(apiEndpoints.users, params);
};

/**
 * Fetches a user details
 * @param {String} userId Id of the user whose details are to be fetched
 * @param {Object} params Http request payload
 * @returns {Promise} User details
 */
export const getUser = (userId, params = null) => {
  return $admin.get(`${apiEndpoints.users}/${userId}`, { params });
};

/**
 * Delete user
 * @param {String} userId Id of the user to be deleted
 * @param {Object} params Http request payload
 * @returns {Promise} Details of the delete user
 */
export const deleteUser = (userId, params = null) => {
  return $admin.delete(`${apiEndpoints.users}/${userId}`, { params });
};

/**
 * Fetches list of customers a user have access to
 * @param {String} userId Id of the user whose customers have to be fetches
 * @param {Object} params Http request payload
 * @returns {Promise} List of customers a user have access to
 */
export const getUserCustomers = (userId, params) => {
  const endpoint = `${apiEndpoints.users}/${userId}${apiEndpoints.customers}`;
  return $admin.get(endpoint, { params });
};
